import { useIsLoggedSealdOnly } from "core/model/patients/encryption/useIsLoggedSealdOnly";
import {
  Account,
  ApolloEncryptionContext,
  EncryptedField,
  Patient,
} from "core/types";
import { useEncryption } from "dsl/atoms/Contexts";
import { useTracking } from "react-tracking";
import { usePrivateKey } from "reduxentities/hooks";

export function getPatientSessionKey(
  account: Account | null | undefined,
  patient: Patient | null | undefined,
) {
  if (!account || !patient) return null;

  const { id } = account;
  const { session_key_context, session_keys } = patient;

  return session_key_context?.has_session_keys
    ? session_key_context?.session_key
    : session_keys?.find(({ account_id }) => account_id === id);
}

export function getDecryptedValue(v: EncryptedField | null | undefined) {
  if (!v) return null;
  return v.decrypted;
}

export function toEncryptedField(value: string): EncryptedField {
  return {
    content: "",
    decrypted: value,
    iv: "",
    seald_content: "",
  };
}

export function useApolloEncryptionContext(
  context: Partial<Omit<ApolloEncryptionContext, "privateKey">> = {},
): ApolloEncryptionContext {
  const privateKey = usePrivateKey();
  const { trackEvent } = useTracking();

  // Consider encryption is only enabled for patientType != CARE, so
  // this will be false when outside of the PatientContext scope
  // Thus allowing decrypt to be passed to the hook to override for the dashboards for ex.
  const { encryptionAvailable } = useEncryption();
  const isSealdOnly = useIsLoggedSealdOnly();

  return {
    decrypt: encryptionAvailable,
    isSealdOnly,
    privateKey,
    trackEvent,
    ...context,
  };
}

export const NO_ENCRYPTION_DENIED = "denied";
